/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BlockUnblockUserMutationVariables = {
    unblock: boolean;
    mobile: string;
    reason: string;
    byLegalEntity: boolean;
};
export type BlockUnblockUserMutationResponse = {
    readonly blockUser?: {
        readonly success: boolean;
        readonly message: string;
        readonly wallet: {
            readonly " $fragmentRefs": FragmentRefs<"BlockUnblockUser_wallet">;
        } | null;
        readonly unregisteredMobile: {
            readonly mobile: string;
            readonly " $fragmentRefs": FragmentRefs<"BlockUnblockUser_unregisteredMobile" | "UnregisteredMobileInfoHeader_unregisteredMobile" | "NoUserPanel_unregisteredMobile">;
        } | null;
    } | null | undefined;
    readonly unblockUser?: {
        readonly success: boolean;
        readonly message: string;
        readonly wallet: {
            readonly " $fragmentRefs": FragmentRefs<"BlockUnblockUser_wallet">;
        } | null;
        readonly unregisteredMobile: {
            readonly mobile: string;
            readonly " $fragmentRefs": FragmentRefs<"BlockUnblockUser_unregisteredMobile" | "UnregisteredMobileInfoHeader_unregisteredMobile" | "NoUserPanel_unregisteredMobile">;
        } | null;
    } | null | undefined;
};
export type BlockUnblockUserMutation = {
    readonly response: BlockUnblockUserMutationResponse;
    readonly variables: BlockUnblockUserMutationVariables;
};



/*
mutation BlockUnblockUserMutation(
  $unblock: Boolean!
  $mobile: String!
  $reason: String!
  $byLegalEntity: Boolean!
) {
  blockUser(mobile: $mobile, reason: $reason, blockLegalEntity: $byLegalEntity) @skip(if: $unblock) {
    success
    message
    wallet {
      ...BlockUnblockUser_wallet
      id
    }
    unregisteredMobile {
      mobile
      ...BlockUnblockUser_unregisteredMobile
      ...UnregisteredMobileInfoHeader_unregisteredMobile
      ...NoUserPanel_unregisteredMobile
      id
    }
  }
  unblockUser(mobile: $mobile, reason: $reason, unblockLegalEntity: $byLegalEntity) @include(if: $unblock) {
    success
    message
    wallet {
      ...BlockUnblockUser_wallet
      id
    }
    unregisteredMobile {
      mobile
      ...BlockUnblockUser_unregisteredMobile
      ...UnregisteredMobileInfoHeader_unregisteredMobile
      ...NoUserPanel_unregisteredMobile
      id
    }
  }
}

fragment BlockUnblockUser_unregisteredMobile on UnregisteredMobile {
  mobile
  activeBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
    whenExpires
    requestToModifyBlockTickets {
      status
      whenOpened
    }
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
}

fragment BlockUnblockUser_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
  }
  activeLegalEntityBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
}

fragment NoUserPanel_unregisteredMobile on UnregisteredMobile {
  ...BlockUnblockUser_unregisteredMobile
  ...RequestToBlockUnblockUser_unregisteredMobile
  ...UnregisteredMobileInfoHeader_unregisteredMobile
  ...UnregisteredMobileBlocks_blockData
  mobile
  activeBlock {
    blockReason
    blockedBy
    whenBlocked
    blockSubject
    requestToModifyBlockTickets {
      status
    }
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment RequestToBlockUnblockUser_unregisteredMobile on UnregisteredMobile {
  mobile
  activeBlock {
    blockReason
    blockedBy
    whenBlocked
    blockSubject
    whenExpires
    requestToModifyBlockTickets {
      status
      whenOpened
    }
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment RequestToModifyBlock_activeBlock on ActiveBlock {
  id
  requestToModifyBlockTickets {
    status
    whenOpened
  }
}

fragment UnregisteredMobileBlocks_blockData on UnregisteredMobile {
  ...RequestToBlockUnblockUser_unregisteredMobile
  ...BlockUnblockUser_unregisteredMobile
  mobile
  activeBlock {
    ...RequestToModifyBlock_activeBlock
    ...UpdateBlock_activeBlock
    blockReason
    blockedBy
    whenBlocked
    blockSubject
    whenExpires
    requestToModifyBlockTickets {
      status
      whenOpened
    }
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  devices {
    deviceId
    deviceName
    deviceModel
    activeBlock {
      id
      blockReason
      blockedBy
      whenBlocked
      whenExpires
      requestToModifyBlockTickets {
        status
        whenOpened
      }
      ...RequestToModifyBlock_activeBlock
      ...UpdateBlock_activeBlock
    }
  }
}

fragment UnregisteredMobileInfoHeader_unregisteredMobile on UnregisteredMobile {
  ...BlockUnblockUser_unregisteredMobile
  ...UnregisteredMobileBlocks_blockData
  mobile
}

fragment UpdateBlock_activeBlock on ActiveBlock {
  id
  blockReason
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "byLegalEntity"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobile"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reason"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unblock"
},
v4 = {
  "kind": "Variable",
  "name": "mobile",
  "variableName": "mobile"
},
v5 = {
  "kind": "Variable",
  "name": "reason",
  "variableName": "reason"
},
v6 = [
  {
    "kind": "Variable",
    "name": "blockLegalEntity",
    "variableName": "byLegalEntity"
  },
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v10 = [
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Wallet",
    "kind": "LinkedField",
    "name": "wallet",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "BlockUnblockUser_wallet"
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UnregisteredMobile",
    "kind": "LinkedField",
    "name": "unregisteredMobile",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "BlockUnblockUser_unregisteredMobile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UnregisteredMobileInfoHeader_unregisteredMobile"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "NoUserPanel_unregisteredMobile"
      }
    ],
    "storageKey": null
  }
],
v11 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "unblockLegalEntity",
    "variableName": "byLegalEntity"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockReason",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockedBy",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenBlocked",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockSubject",
  "storageKey": null
},
v17 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Block",
  "kind": "LinkedField",
  "name": "blockHistory",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    (v14/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whenUnblocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unblockedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unblockReason",
      "storageKey": null
    },
    (v16/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenExpires",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenOpened",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketShortInfo",
  "kind": "LinkedField",
  "name": "requestToModifyBlockTickets",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = [
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Wallet",
    "kind": "LinkedField",
    "name": "wallet",
    "plural": false,
    "selections": [
      (v12/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ActiveBlock",
        "kind": "LinkedField",
        "name": "activeMobileBlock",
        "plural": false,
        "selections": (v17/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ActiveBlock",
        "kind": "LinkedField",
        "name": "activeLegalEntityBlock",
        "plural": false,
        "selections": (v17/*: any*/),
        "storageKey": null
      },
      (v18/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UnregisteredMobile",
    "kind": "LinkedField",
    "name": "unregisteredMobile",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ActiveBlock",
        "kind": "LinkedField",
        "name": "activeBlock",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v19/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      (v18/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketShortInfo",
        "kind": "LinkedField",
        "name": "tickets",
        "plural": true,
        "selections": [
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "whenResolved",
            "storageKey": null
          },
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slackMessageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ticketType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reference",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserDevice",
        "kind": "LinkedField",
        "name": "devices",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deviceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deviceName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deviceModel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveBlock",
            "kind": "LinkedField",
            "name": "activeBlock",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v19/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v12/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BlockUnblockUserMutation",
    "selections": [
      {
        "condition": "unblock",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "BlockUser",
            "kind": "LinkedField",
            "name": "blockUser",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "unblock",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "UnblockUser",
            "kind": "LinkedField",
            "name": "unblockUser",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BlockUnblockUserMutation",
    "selections": [
      {
        "condition": "unblock",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "BlockUser",
            "kind": "LinkedField",
            "name": "blockUser",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "unblock",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "UnblockUser",
            "kind": "LinkedField",
            "name": "unblockUser",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9d4fdaeff3175dd3739c1aae05fcb788",
    "id": null,
    "metadata": {},
    "name": "BlockUnblockUserMutation",
    "operationKind": "mutation",
    "text": "mutation BlockUnblockUserMutation(\n  $unblock: Boolean!\n  $mobile: String!\n  $reason: String!\n  $byLegalEntity: Boolean!\n) {\n  blockUser(mobile: $mobile, reason: $reason, blockLegalEntity: $byLegalEntity) @skip(if: $unblock) {\n    success\n    message\n    wallet {\n      ...BlockUnblockUser_wallet\n      id\n    }\n    unregisteredMobile {\n      mobile\n      ...BlockUnblockUser_unregisteredMobile\n      ...UnregisteredMobileInfoHeader_unregisteredMobile\n      ...NoUserPanel_unregisteredMobile\n      id\n    }\n  }\n  unblockUser(mobile: $mobile, reason: $reason, unblockLegalEntity: $byLegalEntity) @include(if: $unblock) {\n    success\n    message\n    wallet {\n      ...BlockUnblockUser_wallet\n      id\n    }\n    unregisteredMobile {\n      mobile\n      ...BlockUnblockUser_unregisteredMobile\n      ...UnregisteredMobileInfoHeader_unregisteredMobile\n      ...NoUserPanel_unregisteredMobile\n      id\n    }\n  }\n}\n\nfragment BlockUnblockUser_unregisteredMobile on UnregisteredMobile {\n  mobile\n  activeBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n    whenExpires\n    requestToModifyBlockTickets {\n      status\n      whenOpened\n    }\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n}\n\nfragment BlockUnblockUser_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n  }\n  activeLegalEntityBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n}\n\nfragment NoUserPanel_unregisteredMobile on UnregisteredMobile {\n  ...BlockUnblockUser_unregisteredMobile\n  ...RequestToBlockUnblockUser_unregisteredMobile\n  ...UnregisteredMobileInfoHeader_unregisteredMobile\n  ...UnregisteredMobileBlocks_blockData\n  mobile\n  activeBlock {\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n    requestToModifyBlockTickets {\n      status\n    }\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment RequestToBlockUnblockUser_unregisteredMobile on UnregisteredMobile {\n  mobile\n  activeBlock {\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n    whenExpires\n    requestToModifyBlockTickets {\n      status\n      whenOpened\n    }\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment RequestToModifyBlock_activeBlock on ActiveBlock {\n  id\n  requestToModifyBlockTickets {\n    status\n    whenOpened\n  }\n}\n\nfragment UnregisteredMobileBlocks_blockData on UnregisteredMobile {\n  ...RequestToBlockUnblockUser_unregisteredMobile\n  ...BlockUnblockUser_unregisteredMobile\n  mobile\n  activeBlock {\n    ...RequestToModifyBlock_activeBlock\n    ...UpdateBlock_activeBlock\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n    whenExpires\n    requestToModifyBlockTickets {\n      status\n      whenOpened\n    }\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  devices {\n    deviceId\n    deviceName\n    deviceModel\n    activeBlock {\n      id\n      blockReason\n      blockedBy\n      whenBlocked\n      whenExpires\n      requestToModifyBlockTickets {\n        status\n        whenOpened\n      }\n      ...RequestToModifyBlock_activeBlock\n      ...UpdateBlock_activeBlock\n    }\n  }\n}\n\nfragment UnregisteredMobileInfoHeader_unregisteredMobile on UnregisteredMobile {\n  ...BlockUnblockUser_unregisteredMobile\n  ...UnregisteredMobileBlocks_blockData\n  mobile\n}\n\nfragment UpdateBlock_activeBlock on ActiveBlock {\n  id\n  blockReason\n}\n"
  }
};
})();
(node as any).hash = 'cacf7cca90ee30f262b9e97471643211';
export default node;
